import { tokens } from '@servicetitan/tokens';

/**
 * A simple vertical divider to separate call control buttons which were stacked via with Anvil 1 Button Group.
 *
 * Note: the Anvil 1 Divider implementation (span with a set border) does not support the current designs nicely.
 *
 * @returns a simple divider for the call controls
 */
export function CallControlsDivider() {
  return (
    <div>
      <div
        style={{
          backgroundColor: tokens.colorNeutral60,
          width: '1px',
          height: '40px',
        }}
      ></div>
    </div>
  );
}
